/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import styles from './Modal.Footer.module.scss';

const ModalFooter: React.FC<React.HTMLProps<HTMLDivElement>> = ({
  className,
  children,
  ...props
}) => (
  <div className={classNames(styles.modalFooter, className)} {...props}>
    {children}
  </div>
);

export default ModalFooter;
